import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=c27a9976&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Main.vue?vue&type=style&index=1&id=c27a9976&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27a9976",
  null
  
)

export default component.exports